import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/app/error.tsx");
